import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

// Rival Tracker usage for the current game (x-game-info is added by `agent`).
const getSummary = async () => {
  const response = await agent.get(`${API_URL}rival-tracker/summary`)
  return response.data
}

const getMembers = async (itemsPerPage = 10, activePage = 1, params = '') => {
  const response = await agent.get(
    `${API_URL}rival-tracker/members?limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

// Every member row, unpaginated - used for the CSV export.
const getAllMembers = async () => {
  const response = await agent.get(`${API_URL}rival-tracker/members?all=1`)
  return response.data
}

const getMemberRivals = async (userId) => {
  const response = await agent.get(`${API_URL}rival-tracker/members/${userId}`)
  return response.data
}

const RivalTrackerService = {
  getSummary,
  getMembers,
  getAllMembers,
  getMemberRivals,
}

export default RivalTrackerService
